import * as constants from "../constants/Constants";

const getRoleFromToken = (token) => {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    const decodedToken = JSON.parse(jsonPayload);
    return decodedToken?.role || null;
  } catch (error) {
    console.error("Error decoding token:", error);
    return null;
  }
};

export const verifyOTP = async (data) => {
  try {
    const response = await fetch(constants.apiUrl + "api/v1/verify_ezp_OTP", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    });
    const resData = await response.json();
    if (resData.status !== 200 || resData.success !== true) {
      let message = resData.message ? resData.message : resData.errors[0].msg;
      throw new Error(message);
    } else {
      localStorage.setItem("token", resData.token);
      localStorage.setItem("refresh_token", resData.refresh_token);
      localStorage.setItem("userId", resData.user_details.id);
      return resData;
    }
  } catch (error) {
    throw new Error(error);
  }
};

export const verifyCODE = async (data) => {
  try {
    const response = await fetch(constants.apiUrl + "api/v1/verifyCODE", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    });
    const resData = await response.json();
    if (resData.status !== 200 || resData.success !== true) {
      let message = resData.message ? resData.message : resData.errors[0].msg;
      throw new Error(message);
    } else {
      localStorage.setItem("token", resData.token);
      localStorage.setItem("refresh_token", resData.refresh_token);
      localStorage.setItem("userId", resData.user_details.id);
      return resData;
    }
  } catch (error) {
    throw new Error(error);
  }
};

export const ezp_password_verify = async (data) => {
  try {
    const response = await fetch(
      constants.apiUrl + "api/v1/ezp_password_verify",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
      }
    );
    const resData = await response.json();
    if (resData.status !== 200 || resData.success !== true) {
      let message = resData.message ? resData.message : resData.errors[0].msg;
      throw new Error(message);
    } else {
      localStorage.setItem("token", resData.token);
      localStorage.setItem("refresh_token", resData.refresh_token);
      localStorage.setItem("userId", resData.user_id);
      return resData;
    }
  } catch (error) {
    throw new Error(error);
  }
};

export const regenerateToken = async (method, url, data) => {
  try {
    var refreshToken = localStorage.getItem("refresh_token");
    const response = await fetch(constants.apiUrl + "api/v1/refreshToken", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
        // 'isMobile': false
      },
      body: JSON.stringify({
        refreshToken: refreshToken
      })
    });
    const resData = await response.json();
    if (resData.status !== 200 || resData.success !== true) {
      localStorage.clear();
      window.location.href = "/login";
    } else {
      localStorage.setItem("token", resData.token);
      localStorage.setItem("refresh_token", resData.refresh_token);
      if (method === "GET") {
        return get(url);
      } else if (method === "POST") {
        return post(data, url);
      } else if (method === "DELETE") {
        // del() used to land in the else below, so an expired token on any delete wiped the session.
        return del(url);
      } else {
        localStorage.clear();
        window.location.href = "/login";
      }
    }
  } catch (error) {
    localStorage.clear();
    window.location.href = "/login";
  }
};

export const get = async (url) => {
  try {
    const token = localStorage.getItem("token");
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    };

    const response = await fetch(constants.apiUrl + "api/v1/" + url, {
      method: "GET",
      headers: headers
    });

    // Log the raw response text for debugging
    const responseText = await response.text();

    // Try to parse it as JSON
    const data = responseText ? JSON.parse(responseText) : {};

    if (data.status === 401) {
      return regenerateToken("GET", url, null);
    } else if (!response.ok) {
      throw new Error(data.message || "API request failed");
    }
    return data;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};

export const post = async (data, url, isFormData = false) => {
  try {
    const token = localStorage.getItem("token") || null;

    const response = await fetch(constants.apiUrl + "api/v1/" + url, {
      method: "POST",
      headers: {
        ...(isFormData ? {} : { "Content-Type": "application/json" }),
        isMobile: false,
        Authorization: "Bearer " + token
      },
      body: isFormData ? data : JSON.stringify(data)
    });

    const resData = await response.json();

    if (resData.status === 401) {
      return regenerateToken("POST", url, data);
    }

    // ❗ IMPORTANT: ALWAYS RETURN RESPONSE (success or fail)
    return resData;
  } catch (error) {
    console.error("API Error:", error);

    return {
      success: false,
      message: error.message || "Something went wrong"
    };
  }
};

export const generate_pdf = async (data, url, isFormData = false) => {
  try {
    const token = localStorage.getItem("token") || null;

    const response = await fetch(constants.apiUrl + "api/v1/" + url, {
      method: "POST",
      headers: {
        ...(isFormData ? {} : { "Content-Type": "application/json" }),
        isMobile: false,
        Authorization: "Bearer " + token
      },
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      const errText = await response.text();
      throw new Error(`Server error: ${response.status} - ${errText}`);
    }

    // ✅ Get filename from header
    const contentDisposition = response.headers.get("Content-Disposition");

    let fileName = "document.pdf"; // fallback name

    if (contentDisposition) {
      // let f1 = "attachment; filename = INV_P_00001.pdf";

      fileName = contentDisposition?.split("=")?.[1]?.trim()?.replace(/"/g, "");

      // const match = contentDisposition.match(/filename="?(.+?)"?$/);
      // if (match && match[1]) {
      //   fileName = match[1];
      // }
    }

    const blob = await response.blob();

    if (blob.type !== "application/pdf") {
      const text = await blob.text();
      throw new Error("Response is not a PDF: " + text);
    }

    const downloadUrl = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = downloadUrl;
    a.download = fileName; // ✅ dynamic filename
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(downloadUrl); // ✅ cleanup memory

    return true;
  } catch (error) {
    console.error("PDF Error:", error);
    throw new Error(error.message || error);
  }
};
// POSTs and saves whatever file the API sends back (zip, csv, ...), named from Content-Disposition.
// generate_pdf is the PDF-only variant.
export const download_file = async (data, url, fallbackName = "download") => {
  const token = localStorage.getItem("token") || null;
  const response = await fetch(constants.apiUrl + "api/v1/" + url, {
    method: "POST",
    headers: { "Content-Type": "application/json", isMobile: false, Authorization: "Bearer " + token },
    body: JSON.stringify(data || {}),
  });
  if (!response.ok) throw new Error(`Server error: ${response.status} - ${await response.text()}`);
  const disposition = response.headers.get("Content-Disposition") || "";
  const match = /filename="?([^";]+)"?/i.exec(disposition);
  const blob = await response.blob();
  const href = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = href;
  a.download = match ? match[1] : fallbackName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(href);
  return true;
};

export const del = async (url) => {
  try {
    const token = localStorage.getItem("token") || null;
    const response = await fetch(constants.apiUrl + "api/v1/" + url, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token
      }
    });

    const resText = await response.text();
    const data = resText ? JSON.parse(resText) : {};

    if (data.status === 401) {
      // handle token refresh
      return regenerateToken("DELETE", url, null);
    } else if (!response.ok) {
      throw new Error(data.message || "API request failed");
    }

    return data;
  } catch (error) {
    console.error("API DELETE Error:", error);
    throw new Error(error.message || "Something went wrong");
  }
};
export const getRole = () => {
  const token = localStorage.getItem("token");
  if (!token) return null;
  // console.log("getRoleFromToken(token)", getRoleFromToken(token));
  return getRoleFromToken(token);
};
